import moment from "moment/moment";
import request from "@/utils/request";
import gridFormat from "@/utils/gridFormat";
const getHourly = (lat: number, lon: number, limit: number = 24) => {
  const params = {
    lon,
    lat,
    elements: "t2m,wp,rain,10uv",
    limit,
  };
  return request.get("/gpr/point", params).then((res) => {
    if (!res || res.length == 0) return;
    for (const e of res) if (e.wp == undefined) return; // 保证有数据
    const current = moment(new Date()).format("YYYYMMDDHH0000");
    let i = 0;
    res.map((e: any, index: any) => {
      e.wpimg = gridFormat.formatSkyConIcon(e.wp);
      e.wpdesc = gridFormat.formatWeather(e.wp);
      e.time = moment(e.dataTime, "YYYYMMDDHH")
        .add(8, "hours")
        .format("HH:00");
      if (e.dataTime === current) {
        i = index;
      }
    });
    const dataArray = res.slice(i + 1, i + 13);
    return dataArray;
  });
};
const get12hours = (lat: number, lon: number, limit: number = 16) => {
  // 获取12小时预报数据：天气现象
  const params = {
    lon,
    lat,
    elements: "wp12",
    limit,
  };
  return request.get("/gpr/point", params).then((res: any) => {
    console.log(res)
    if (!res || res.length == 0) return;
    for (const e of res) if (e.wp12 == undefined) return; // 保证有天气现象
    return res;
  });
};
const getDaily = (lat: number, lon: number, limit: number = 7) => {
  const params = {
    lon,
    lat,
    elements: "tmax24,tmin24,rain24",
    limit,
  };
  return request.get("/gpr/point", params).then((res: any) => {
    if (!res || res.length == 0) return;
    for (const e of res)
      if (e.tmin24 == undefined || e.tmax24 == undefined) return; // 保证有数据
    return res;
  });
};
export default {
  getHourly,
  get12hours,
  getDaily,
};
